<template>
    <Navbar></Navbar>
    <div class="product-page">
        <div class="product-kv">
            <div class="swiper-container kv-container" ref="swiperRefs">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <video class="pc-pad" data-src="/assets/product/transmission/transmission-kv1.mp4" alt=""
                                muted loop autoplay playsinline webkit-playsinline="true" x5-video-player-type="h5"
                                x5-video-player-fullscreen="true"></video>
                            <video class="mb-only" data-src="/assets/product/transmission/transmission-kv1-m.mp4" alt=""
                                muted loop autoplay playsinline webkit-playsinline="true" x5-video-player-type="h5"
                                x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
                        </div>
                        <div class="text-box">
                            <div class="title">
                                Efficient Transmission<br />Reliability Forged by Strength
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="product-content">
            <div class="product-content-item" v-if="swiperData[2]">
                <div class="content-item-t">
                    {{ swiperData[2].name }}
                </div>

                <div class="img-box content-item-img">
                    <img src="/assets/product/transmission/150kW-M/150kW-M.jpg" alt="">
                </div>

                <div class="content-item-list">
                    <a v-for="(value, index) in swiperData[2].itemData" :key="index"
                        :href="value.productUrl || 'javascript:;'" target="_blank">
                        {{ value.name }}
                    </a>
                </div>
            </div>
            <div class="product-content-r">
                <div class="product-content-item" v-if="swiperData[1]">
                    <div class="content-item-t">
                        {{ swiperData[1].name }}
                    </div>

                    <div class="img-box content-item-img">
                        <img src="/assets/product/transmission/DHT3L/DHT3L.jpg" alt="">
                    </div>

                    <div class="content-item-list">
                        <a v-for="(value, index) in swiperData[1].itemData" :key="index"
                            :href="value.productUrl || 'javascript:;'" target="_blank">
                            {{ value.name }}
                        </a>
                    </div>
                </div>
                <div class="product-content-item" v-if="swiperData[0]">
                    <div class="content-item-t">
                        {{ swiperData[0].name }}
                    </div>

                    <div class="img-box content-item-img">
                        <img src="/assets/product/transmission/9AT/9AT.jpg" alt="">
                    </div>

                    <div class="content-item-list">
                        <a v-for="(value, index) in swiperData[0].itemData" :key="index" :href="value.productUrl"
                            target="_blank">
                            {{ value.name }}
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>


<script setup>
import { ref, onMounted, nextTick, onUnmounted, watch } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { listSecond, productList } from '@/utils/common.js'

const swiperRefs = ref(null);
const swiperInstances = ref([]);
const initAllSwipers = async () => {
    await nextTick();
    const el = swiperRefs.value;
    if (el) {
        const swiper = new Swiper(el, {
            speed: 1300,
            pagination: {
                el: el.querySelector(".swiper-pagination"),
                clickable: true,
            },
            direction: "horizontal",
            simulateTouch: true,
            breakpoints: {
                768: {},
                1024: {}
            },
            on: {
                init: function () { },
                slideChangeTransitionStart(swiper) {
                    let swiperIndex = swiper.realIndex;
                },
            },
        });
        swiperInstances.value.push(swiper);
    }
};

const swiperData = ref([])

const getListSecond = async () => {
    try {
        const res = await listSecond({
            pageNum: 1,
            pageSize: 20,
            categoryId: 5,
            publishStatus: 3
        });
        // 修复5：先创建完整数组，避免异步赋值导致的索引错乱
        const tempData = res.rows.map(item => ({
            ...item,
            itemData: []  // 初始化空数组，避免undefined
        }));
        swiperData.value = tempData;

        // 批量请求子数据
        await Promise.all(
            tempData.map((item, index) => getSecondData(item.id, index))
        );

    } catch (error) {
        console.error('获取二级列表失败:', error);
    }
};

const getSecondData = async (id, index) => {
    try {
        const response = await productList({
            pageNum: 1,
            pageSize: 20,
            categoryId: 5,
            categorySecondId: id,
            publishStatus: 3
        });
        // 修复6：安全赋值，避免索引越界
        if (swiperData.value[index]) {
            swiperData.value[index].itemData = response.rows || [];
        }
    } catch (error) {
        console.error(`获取子数据失败(id:${id}):`, error);
        // 修复7：异常时初始化空数组，避免后续渲染报错
        if (swiperData.value[index]) {
            swiperData.value[index].itemData = [];
        }
    }
};

onMounted(() => {
    initAllSwipers();
    getListSecond();
});

onUnmounted(() => {
    // 修复8：销毁swiper实例，避免内存泄漏
    swiperInstances.value.forEach(swiper => swiper.destroy(true, true));
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Transmission System - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission.html'
};

import { createApp } from 'vue';
import App from './transmission.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./transmission.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped>
.product-kv {
    min-height: 100vh;
}

.kv-container {
    width: 100%;
    height: auto;

    .text-box {
        position: absolute;
        top: 2.34rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;

        .title {
            font-size: 0.5rem;
            font-weight: 800;
            white-space: nowrap;
            text-align: center;
        }

        .text {
            font-size: 0.2rem;
            font-weight: 300;
        }

        .product-kv-btn {
            background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
            width: 1.71rem;
            height: 0.45rem;
            border-radius: 0.26rem;
            display: flex;
            justify-content: center;
            align-items: center;

            div {
                color: #fff;
                font-size: 0.13rem;
                font-weight: 400;
                width: 70%;
                text-align: center;
            }

            img {
                width: 0.25rem;
                height: 0.25rem;
                object-fit: cover;
            }
        }
    }
}

.product-content {
    padding: 0 1.56rem;
    width: calc(100% - 3.12rem);
    margin-top: 1.17rem;
    margin-bottom: 1.17rem;
    display: flex;
    gap: 0.2rem;

    .product-content-item {
        width: 7.94rem;
        background: #F8FAFB;
        border-radius: 0.15rem;
        overflow: hidden;
        position: relative;
        height: 8.79rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.89rem;



        .content-item-t {
            height: 0.64rem;
            background: #f4f4f4;
            display: flex;
            align-items: center;
            padding-left: 0.39rem;
            width: calc(100% - 0.39rem);
            color: #000;
            font-weight: 600;
            font-size: 0.22rem;
        }

        .content-item-img {
            width: 5.08rem;
        }

        .content-item-list {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            gap: 0.15rem;
            position: absolute;
            bottom: 0.37rem;
            left: 4%;
            width: 92%;

            a {
                padding: 0.1rem 0.2rem;
                border: 1px solid #676767;
                border-radius: 0.3rem;
                font-size: 0.13rem;
                transition: all 0.3s ease;

                &:hover {
                    background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                    color: #fff;
                    border: none;
                }
            }
        }
    }

    .product-content-r {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;

        .product-content-item {
            flex: 1;
            height: 4.3rem;
            gap: 0;

            .content-item-img {
                width: 2.93rem;
            }
        }
    }
}
@media (max-width: 768px) {

.product-kv {
    min-height: auto;
}
    .kv-container {
        .text-box {
            top: 2.69rem;
            width: auto;
            text-wrap: nowrap;
        }
    }
    .product-content{
        padding: 1.1rem 0.45rem 0;
        width: calc(100% - 0.9rem);
        flex-direction: column;
        margin-top:0;
        .product-content-item{
            width: 100%;
            height: auto;
            padding-bottom: 0.5rem;
            .content-item-t{ 
                font-size: 0.26rem;
                height: 0.7rem;
            }
            .content-item-img{
                width: 2.93rem;
            }
            .content-item-list{
                position: unset;
            }
        }
    }
}
</style>